import { useEffect, useRef, useState } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export const HeaderCategoryList = [
  {
    id: 1,
    title: "회사소개",
    link: "#about",
  },
  {
    id: 2,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 3,
    title: `작업사례`,
    link: "#blog",
  },
  {
    id: 4,
    title: `최신장비`,
    link: "#equip",
  },
  {
    id: 5,
    title: `상세\u00A0견적문의`,
    link: "#contact",
  },
];

const MHeader = () => {
  const navigate = useNavigate();

  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const [white, setWhite] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 180) setWhite(true);
      else setWhite(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        if (window.pageYOffset > 180) setWhite(true);
        else setWhite(false);
      });
    };
  }, []);

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const headerCss = ` relative w-full h-fit px-[calc((100%-var(--container))/5)] 3xl:px-[calc((100%-var(--container))/2)] max-h-20 lg:max-h-32 py-2 lg:py-5 overflow-hidden z-40 transition-all duration-300`;

  return (
    <header className="fixed left-0 top-0 w-full h-fit z-40">
      <div
        ref={headerRef}
        id="header"
        className={
          white
            ? "bg-white bg-opacity-80" + headerCss
            : "bg-transparent" + headerCss
        }
      >
        <div className="relative w-full h-full mx-auto flex justify-between items-end gap-6 xl:gap-16 2xl:gap-20">
          <Burger
            ref={burgerIconRef}
            opened={opened}
            onClick={toggle}
            className="block xl:hidden"
            size="md"
            color="blue"
          />
          <div className="flex justify-start items-center gap-3">
            <img
              alt="장인배관 로고"
              onClick={() => navigate("/")}
              className="!relative w-full h-full max-w-md max-h-8 lg:max-h-12 2xl:max-h-16 py-1 object-contain cursor-pointer"
              src={white ? "/images/logo.png" : "/images/whiteLogo.png"}
              width={395}
              height={100}
            />
            <img
              src={white ? "/images/x.png" : "/images/whiteX.png"}
              alt="구분 기호"
              width={29}
              height={29}
              className="hidden lg:inline-block !relative w-auto h-full max-h-5 mt-3"
            />
            <img
              src={white ? "/images/btn1.png" : "/images/whiteBtn1.png"}
              alt="장인배관 누수탐지 전문 안내"
              width={251}
              height={64}
              className="hidden lg:inline-block !relative w-auto h-full max-h-11 object-contain -mt-3.5"
            />
            <img
              src={white ? "/images/btn2.png" : "/images/whiteBtn2.png"}
              alt="장인배관 누수공사 전문 안내"
              width={243}
              height={46}
              className="hidden lg:inline-block !relative w-auto h-full max-h-8 object-contain"
            />
            <img
              src={white ? "/images/btn3.png" : "/images/whiteBtn3.png"}
              alt="장인배관 고압세척 전문 안내"
              width={243}
              height={61}
              className="hidden lg:inline-block !relative w-auto h-full max-h-11 object-contain"
            />
          </div>
          <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
            <IconBrandWhatsapp
              onClick={() => {
                window.location.href = "tel:010-3409-5404";
              }}
              size={30}
              stroke={1}
              color={white ? "blue" : "white"}
            />
          </div>
          <div className="hidden xl:block relative w-fit h-fit max-w-96 3xl:max-w-none">
            <img
              onClick={() => {
                window.location.href = "tel:010-3409-5404";
              }}
              className="!relative w-full h-full max-h-12 3xl:max-h-14 object-contain cursor-pointer"
              alt="장인배관 전화 상담 버튼 010-3409-5404"
              src={white ? "/images/contactCall.png" : "/images/rightNum.png"}
              width={532}
              height={132}
            />
          </div>
        </div>
      </div>
      <div
        ref={phoneMenuListRef}
        className="block xl:hidden fixed top-[50px] left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
      >
        {" "}
        <ul className="border-b bg-white bg-opacity-80 text-font">
          {HeaderCategoryList.map((v, i) => (
            <li
              key={i}
              onClick={() => phoneMenuOnclick(v.link)}
              className="border-b py-4 text-center"
            >
              <p className={i === 0 ? "text-base font-black" : "text-base"}>
                {v.title}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default MHeader;
